import { FC, ReactNode } from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Breadcrumbs, { BreadcrumbsProps } from 'components/Breadcrumbs';

import { PropType } from 'types/utils';
import { SxProps, Theme } from '@mui/material/styles';

type Props = {
  sidebar: ReactNode;
  breadcrumbs?: PropType<BreadcrumbsProps, 'breadcrumbs'>;
  sx?: SxProps<Theme>;
};

const spacing = 2;

const PageWithSidebar: FC<Props> = ({ children, sidebar, breadcrumbs, sx }) => (
  <Box sx={sx}>
    {breadcrumbs && (
      <Grid container spacing={spacing}>
        <Grid item xs={12}>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </Grid>
      </Grid>
    )}

    <Grid container spacing={spacing}>
      <Grid item xs={9}>
        {children}
      </Grid>

      <Grid item xs={3}>
        {sidebar}
      </Grid>
    </Grid>
  </Box>
);

export default PageWithSidebar;
